import React from 'react';

type PageFooterProps = {
	children?: React.ReactNode
}

const PageFooter: React.FC<PageFooterProps> = props => {
	return(
    <div className="layout-footer">
        Footer
    </div>
	)
}

export default PageFooter;